<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.v-application .subtitle-1 {
  font-family: "Prompt", sans-serif !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
.text_div {
  margin-right: 20px;
  color: black;
  font-weight: bold;
}
.width_combo {
  max-width: 300px;
}
#map-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.pac-target-input {
  border: #b1b1b1 solid 1px;
  max-width: 450px;
  padding: 5px;
  border-radius: 5px;
  text-indent: 10px;
}
</style>

<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        สรุปยอดเผาเก็บขนและกำจัดประจำเดือน {{this.GET_VAL}}
      </div>
      <v-spacer></v-spacer>

      <v-btn color="primary" elevation="0" dark link @click="backToDashboard()">
        <v-icon left>mdi-backburger</v-icon>ย้อนกลับ
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-card>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">วันที่</th>
              <th class="text-left">ยอดยกมา</th>
              <th class="text-left">70-7580</th>
              <th class="text-left">10ล้อ</th>
              <th class="text-left">10ล้อ</th>
              <th class="text-left">โกดัง</th>
              <th class="text-left">เทศบาล</th>
              <th class="text-left">อื่นๆ</th>
              <th class="text-left">รวมขยะ</th>
              <th class="text-left">ส่งกำจัด</th>
              <th class="text-left">กำจัดเคมี</th>
              <th class="text-left">กำจัดเทศบาล</th>
              <th class="text-left">เผาขยะอันตราย</th>
              <th class="text-left">ส่งเผาอื่นๆ</th>
              <th class="text-left">ยอดคงเหลือ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in desserts" :key="item.name">
              <td>{{ item.name }}</td>
              <td>{{ item.calories }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <summaryCollectRemoval />
  </v-container>
</template>
<script>
import summaryCollectRemoval from "../../components/_tableReport/SummaryCollect_Removal";
import { mapMutations, mapGetters } from "vuex";
export default {
  components: {
    summaryCollectRemoval,
  },
  data() {
    return {
      desserts: [],
    };
  },
  computed: {
    ...mapGetters({
      GET_VAL:'SummaryCollectRemoval/GET_VAL'
    }),
  },
  methods: {
    backToDashboard() {
      this.$router.push({ path: "/Dashboard" });
    },
  },
};
</script>
